import axios from "axios";
import { getToken } from "../utils/storage";
import {
  REACT_APP_CHAT_SUPPORT_API_URL,
  REACT_APP_CHAT_SUPPORT_FEEDBACK_URL,
} from "../utils/environment";

// The chat support service lives outside API_URL, so these calls use plain
// axios rather than the shared `api` instance / apiData: their interceptors
// would show the contextual loader and redirect to /logout on a 403. Errors
// are rethrown instead of passed to serviceError so the chat UI decides how
// to show them (an inline chat message or its own popup).
class ChatSupportAPI {
  // Chat History API
  async chatHistoryAPI({ token, phone }) {
    const { data } = await axios({
      url: `${REACT_APP_CHAT_SUPPORT_API_URL}/history`,
      method: "POST",
      data: { token, phone },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return data;
  }

  // Send Chat Message API
  async sendChatMessageAPI(payload, { withAuth = true } = {}) {
    const { data } = await axios({
      url: `${REACT_APP_CHAT_SUPPORT_API_URL}/chat`,
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        ...(withAuth && { Authorization: `Bearer ${getToken()}` }),
      },
    });
    return data;
  }

  // Customer Documents API
  async customerDocumentsAPI(customerID) {
    const { data } = await axios({
      url: `${REACT_APP_CHAT_SUPPORT_API_URL}/documents/${customerID}`,
      method: "GET",
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return data;
  }

  // Document URL API
  async documentUrlAPI(docId) {
    const { data } = await axios({
      url: `${REACT_APP_CHAT_SUPPORT_API_URL}/document-url/${encodeURIComponent(docId)}`,
      method: "GET",
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return data;
  }

  // Chatbot Feedback API
  async chatbotFeedbackAPI(payload) {
    const { data } = await axios({
      url: `${REACT_APP_CHAT_SUPPORT_FEEDBACK_URL}/chatbot-feedback`,
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return data;
  }
}

export default ChatSupportAPI;
